var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TransactionListTemplate',{ref:"awaiting-payment-list",attrs:{"screenConfig":_vm.setScreenConfig,"setLoading":_vm.setLoading,"persistenceKey":'awaiting-payments',"gcPopupConfig":_vm.gcPopupConfig}})
}
var staticRenderFns = []

export { render, staticRenderFns }